const faqData = {
 kneeReplacement: [
  {
    q: "What are the postural modifications for knee pain?",
    a: "Avoid sitting cross-legged.\nAvoid squatting.\nAvoid climbing stairs as much as possible."
  },
  {
    q: "Walking stick – which hand should it be used in?",
    a: "The walking stick should be used in the hand opposite to the affected knee.\nThis improves efficiency of load transmission through the lever arm mechanism, thereby reducing stress on the painful knee."
  },
  {
    q: "Braces or knee cap – which is better?",
    a: "Braces are preferred as they are stronger, provide better support, and are more effective than knee caps."
  },
  {
    q: "Do exercises help? If yes, how?",
    a: "Yes, exercises help by improving muscle strength and flexibility, which reduces stress on the knee joint.\nRecommended exercises include:\nWalking.\nCycling without resistance.\nSwimming."
  },
  {
    q: "What can be done for knee arthritis besides surgery?",
    a: "Conservative options include exercises, physiotherapy, and gel injections.\nHowever, outcomes are not predictable, especially in advanced arthritis."
  },
  {
    q: "Knee injections – what, why, when, and usefulness?",
    a: "Three types of injections are available:\nSteroid injections – provide instant pain relief but for a short duration.\n Hyaluronic acid injections – useful in early-stage osteoarthritis or in severe arthritis for patients who are medically unfit or want to delay surgery temporarily.\n Platelet-rich plasma (PRP) – used in early-stage osteoarthritis and may partially reverse degeneration and help in cartilage regeneration."
  },
  {
    q: "Should I wait as long as possible for knee replacement?",
    a: "Osteoarthritis is a progressive disease.\nUnnecessary delay can further damage joint surfaces, cause bone deformities, restrict movement, and make surgery technically more difficult.\nOver time, overall health may deteriorate, increasing surgical risks.\nSeverely damaged joints may require advanced and expensive implants such as rods or hinges.\nIncreasing age and osteoporosis can compromise implant fixation and longevity."
  },
  {
    q: "Should I continue medications for a long time?",
    a: "Medications provide temporary relief only.\nLong-term use of painkillers can lead to kidney damage and peptic ulcer disease."
  },
  {
    q: "Can alternative therapies cure advanced arthritis?",
    a: "There is no scientifically proven permanent non-surgical cure for advanced osteoarthritis.\nThese therapies may provide temporary relief in early to moderate arthritis.\nFear of surgery often delays proper treatment, but surgery cannot be avoided in advanced stages."
  },
  {
    q: "Am I too old or too young for knee replacement?",
    a: "Age is not a barrier for surgery.\nTotal knee replacement has been successfully performed in patients as young as 45 years and as old as 90 years.\nIf a patient is medically fit and cleared by anesthesia and physician, surgery can be safely performed.\nYounger patients should avoid contact sports to prolong implant life."
  },
  {
    q: "How do I know if knee replacement will help me?",
    a: "Consider surgery if you have persistent pain requiring regular painkillers.\nPain affecting daily activities.\nPain limiting travel and reducing quality of life."
  },
  {
    q: "Is there any harm in waiting?",
    a: "In stage 4 arthritis, progressive deformities should not be ignored.\nDelaying surgery can reduce success rates and increase complexity.\nThe only justified reason to delay surgery is an untreated medical condition."
  },
  {
    q: "Is knee replacement a very painful surgery?",
    a: "Modern techniques such as multimodal pain management, nerve blocks, and local tissue infiltration have made surgery relatively pain-free and patient-friendly."
  },
  {
    q: "Will I have to give up activities after surgery?",
    a: "Most patients return to activities such as cycling and brisk walking.\nSquatting and sitting cross-legged are possible but should be kept minimal to increase implant longevity."
  },
  {
    q: "Can I drive after knee replacement?",
    a: "Yes. Driving is usually possible after 8 weeks."
  },
  {
    q: "How long does complete recovery take?",
    a: "24–48 hours: Walking and independent toilet use.\n3 weeks: Stair climbing and social activities.\n4 weeks: Kitchen activities.\n6 weeks: Most daily activities resumed.\n3 months: Strength and endurance comparable to pre-surgery.\nUp to 6 months: Full recovery depending on health and rehabilitation."
  },
  {
    q: "Is surgery done one knee at a time?",
    a: "If cardiopulmonary status is stable and anesthesia permits, both knees can be replaced in a single stage.\nOtherwise, the second knee is preferably done after 6–12 weeks."
  },
  {
    q: "What are the advantages of replacing both knees at the same time?",
    a: "Early pain relief in both knees.\nBetter gait and walking ability.\nReduced hospital stay, anesthesia exposure, and overall cost by nearly 40%."
  },
  {
    q: "Do implants last only 10 years?",
    a: "With modern surgical precision and advanced biomaterials, implants last 20 years or longer and often a lifetime.\nStudies show 85% of implants placed 20 years ago are still functioning well."
  },
  {
    q: "I am obese – can I undergo knee replacement?",
    a: "Knee replacement can be successfully performed in obese patients with comparable results.\nWeight loss is often difficult due to pain.\nMany patients lose weight after surgery.\nIf body weight exceeds 130 kg, bariatric surgery may be advised first."
  },
  {
    q: "I have diabetes, hypertension, or heart disease – can I have surgery?",
    a: "These conditions are not a contraindication.\nWith proper medical optimization, such patients are good surgical candidates.\nImproved mobility after surgery often leads to better disease control."
  },
  {
    q: "Is my entire knee removed during surgery?",
    a: "No. Only the damaged surfaces are replaced.\nIt is more of a resurfacing procedure than complete replacement."
  },
  {
    q: "Can I choose my implant online?",
    a: "There are many good implant designs and manufacturers.\nDifferent surgeons use different systems.\nIt is best to choose your surgeon and allow them to select the most suitable implant."
  },
  {
    q: "Are expensive implants always better?",
    a: "There is no strong evidence that expensive implants always give better results.\nBoth Indian and imported implants can give excellent outcomes.\nSuccess depends more on surgical technique, postoperative care, and physiotherapy."
  },
  {
    q: "Is computer navigation useful?",
    a: "Evidence suggests computer navigation provides slightly better alignment than conventional techniques."
  },
  {
    q: "Can knee replacement be done again if it fails?",
    a: "Yes. This is called revision knee replacement and has good long-term outcomes when performed appropriately."
  },
  {
    q: "Will my body reject the implant?",
    a: "Implants are biocompatible and inert.\nThey do not cause allergic or rejection reactions."
  },
  {
    q: "Is knee replacement a high-risk surgery?",
    a: "The main risk is infection, which is approximately 2%.\nOverall success rate is around 95%."
  },
  {
    q: "Will I need long-term physiotherapy?",
    a: "99% of patients do not need home physiotherapy.\nExercises are taught in the hospital.\n98% of patients walk without support after 4 weeks."
  }
],
shoulderReplacement: [
  {
    q: "Does the shoulder also become arthritic like the knee?",
    a: 'Yes.\nArthritis refers to wear and tear of joint cartilage and can affect any joint in the body, including the shoulder.\nThe underlying cause may vary depending on age, the joint involved, and prior injury or medical history.\n(Link: <a href="/services/shoulder-pain" class="faq-link">Shoulder Pain</a>)'
  },
  {
    q: "If one shoulder develops arthritis, will the other shoulder also develop arthritis?",
    a: "Not necessarily.\nThe likelihood of the other shoulder developing arthritis depends on the underlying cause, such as age-related degeneration, inflammatory disease, or previous injury."
  },
  {
    q: "Why is screening for common infections required before surgery?",
    a: "Infections from other sites—most commonly dental or urinary tract infections—can spread to the joint through the bloodstream.\nScreening and treating these infections beforehand help reduce the risk of post-operative joint infection."
  },
  {
    q: "How much range of motion can I expect after shoulder replacement surgery?",
    a: "The final range of motion largely depends on the range of motion before surgery.\nIn most cases, patients achieve good movement and are able to use the replaced shoulder comfortably for daily activities."
  },
  {
    q: "What symptoms after surgery are not worrisome?",
    a: '<a href="/services/shoulder-normal"  rel="noopener noreferrer" class="faq-link">What Is Normal After Surgery</a>'
  }

],
shoulderArthroscopy: [
  {
    q: "How does the surgeon see and perform work during shoulder arthroscopy?",
    a: 'Shoulder arthroscopy is a minimally invasive procedure performed using a small camera called an arthroscope, which is inserted through tiny incisions around the shoulder.\nThe camera projects high-resolution images onto a screen, allowing the surgeon to clearly visualize and repair damaged structures inside the joint.\n(Link: <a href="/services/shoulder-arthroscopy" rel="noopener noreferrer" class="faq-link" > What is Shoulder Arthroscopy)</a>'
  },
  {
    q: "Are there risks involved with shoulder arthroscopy?",
    a: 'Like any surgical procedure, shoulder arthroscopy carries some risks, although complications are uncommon.\n(Link: <a href="/services/shoulder-arthroscopy"  rel="noopener noreferrer" class="faq-link">Complications of Shoulder Arthroscopy) </a>'
  },
  {
    q: "When will I have follow-up appointments after surgery?",
    a: "Follow-up visits are important to monitor healing, assess progress, and guide rehabilitation.\nTypical follow-up schedule: 1 week, 2 weeks, 1 month, 2 months, 3 months, 1 year.\nIn many cases, your doctor may advise reviews every 3 weeks, depending on recovery."
  },
  {
    q: "How much pain will I have after surgery?",
    a: "Pain varies greatly from person to person.\nThe same procedure may cause different levels of pain in different patients.\nPain control includes:\nIcing the shoulder.\nAppropriate pain medications.\nLimiting activity.\nFollowing physiotherapy instructions.\nA nerve block is often administered during surgery, providing excellent pain relief for several hours.\nWhen the block wears off, pain may increase temporarily.\nTingling in the arm indicates the block is wearing off—this is the ideal time to start oral pain medication."
  },
  {
    q: "What are the advantages of arthroscopic rotator cuff repair compared to not having surgery?",
    a: "Advantages include:\nSmaller incisions.\nLess blood loss.\nBetter visualization of damaged structures.\nFaster healing.\nImproved functional outcomes compared to non-surgical treatment in indicated cases."
  },
  {
    q: "If pain persists for a few weeks after surgery, is it worrisome?",
    a: "No.\nDespite small incisions, significant work is done inside the shoulder.\nStiffness and soreness for several weeks are normal.\nThe effectiveness of surgery should not be judged until 12–16 weeks after the procedure."
  },
  {
    q: "What conditions require shoulder arthroscopy?",
    a: 'Shoulder arthroscopy is commonly performed for various shoulder conditions.\n(Link: <a href="/services/shoulder-arthroscopy"  rel="noopener noreferrer" class="faq-link"> Indications for Shoulder Arthroscopy</a> )'
  },
  {
    q: "Will I need to use a sling after surgery?",
    a: "Yes.\nA specialized sling is usually worn for 4–6 weeks.\nIt should be worn at all times except during bathing or exercises as advised.\nThe sling protects the shoulder and signals others to be cautious around you.\nYou may remove the sling several times a day to move the elbow, wrist, and hand to prevent stiffness.\nLifting more than 2–5 pounds with the operated arm is not allowed during this period."
  },
  {
    q: "Will surgery restore full range of motion and strength?",
    a: "Most patients regain near-normal range of motion.\nPhysical therapy is critical to prevent stiffness.\nStrength recovery depends on tear size, tissue quality, and duration of injury.\nLarge or chronic tears may not regain full strength, but significant improvement is expected."
  },
  {
    q: "Will I be able to return to the same activities as before surgery?",
    a: "In most cases, yes.\nReturn depends on age, activity level, and type of sport.\nSome patients may experience mild limitations due to stiffness, weakness, or fear of reinjury."
  },
  {
    q: "Will I develop arthritis in my shoulder after surgery?",
    a: "Possibly, but the risk is low.\nSurgery restores function but cannot completely reverse prior joint damage."
  },
  {
    q: "What should I not do after shoulder arthroscopy?",
    a: "Do not lift or bear weight on the arm for 6 weeks.\nDo not reach overhead or behind your back.\nDo not lie on the operated side for 6 weeks.\nDo not get the bandage wet.\nDo not drive until cleared by your doctor."
  },
  {
    q: "Is shoulder arthroscopy safe?",
    a: "Yes.\nShoulder arthroscopy is a very safe procedure with a success rate of 90–95%.\nRare risks include infection, bleeding, nerve injury, blood clots, or swelling."
  }
],
hipReplacement: [
  {
    q: "Do all types of pain in the gluteal or buttock area originate from the hip joint?",
    a: "No.\nPain in the gluteal or buttock region is more commonly related to the spine, whereas pain in the groin region is usually associated with the hip joint."
  },
  {
    q: "Does a replaced hip function like a normal hip during daily activities?",
    a: "Yes.\nA well-performed hip replacement can function almost like a normal, natural hip joint, provided the surgery is done by an experienced hip replacement surgeon and proper postoperative physiotherapy is followed."
  },
  {
    q: "Can I sit cross-legged or use Indian toilets after hip replacement surgery?",
    a: "Some patients may be able to sit cross-legged or use Indian-style toilets; however, this is not recommended.\nThese positions place excessive stress on the hip joint, which can lead to early implant loosening, accelerated wear, and reduced implant lifespan.\nIt is therefore advisable to avoid these activities."
  },
  {
    q: "Is prolonged sitting painful after hip replacement?",
    a: "No.\nHowever, it is advisable to take frequent breaks to prevent muscle stiffness or fatigue associated with prolonged sitting."
  }
],
kneeArthroscopy: [
  {
    q: "My knee feels loose or gives way while walking. Is it a ligament tear?",
    a: "In the absence of any injury or trauma, this sensation may be due to muscle weakness rather than a ligament tear.\nIn such cases, focused physiotherapy is advised to strengthen the surrounding muscles.\nHowever, if there has been a history of injury or trauma, further investigation is required.\nAn MRI scan is usually recommended to confirm the diagnosis of a ligament tear."
  },
  {
    q: "If a ligament is torn, can it heal and become normal again?",
    a: "The healing potential depends on the grade of injury:\nGrade 1: Mild.\nGrade 2: Moderate.\nGrade 3: Severe.\nCertain ligaments, such as the Medial Collateral Ligament (MCL) and Lateral Collateral Ligament (LCL), have the ability to heal and regenerate.\nLigaments like the Anterior Cruciate Ligament (ACL) and Posterior Cruciate Ligament (PCL), which are located inside the joint (intra-articular), have a lower healing capacity and often require surgical treatment in grade 3 tears."
  },
  {
    q: "Will the knee function normally if the meniscus is removed?",
    a: "Yes, normal walking and daily activities are possible even after meniscus removal.\nHowever, the meniscus acts as a cushion in the knee joint.\nIts removal increases the risk of early arthritis.\nTo delay this risk, it is important to maintain a healthy diet, control body weight, and perform regular strengthening exercises."
  },
  {
    q: "Can I play sports, climb stairs, or go trekking after ligament or meniscus repair?",
    a: "Yes. Proper rehabilitation and physiotherapy help restore range of motion, strength, balance, and proprioception.\nOnce the rehabilitation program is completed—usually 1 to 1.5 years after surgery—you may gradually resume sports, trekking, and other physical activities."
  },
  {
    q: "Can I sit cross-legged or use an Indian toilet after ligament or meniscus repair?",
    a: "Yes, but only after 9 months to 1 year.\nAttempting this earlier may cause twisting stress on the repaired structures and is not considered safe.\nRising from these positions places significant load on the knee joint.\nThe timeline may vary depending on individual recovery."
  },
  {
    q: "Can I sit for long periods or travel long distances after ligament or meniscus repair?",
    a: "Yes.\nIt is advisable to keep the leg in a straight position.\nTake frequent breaks during travel.\nPerform gentle warm-up exercises.\nTake short walks if permitted."
  }
],
sportsMedicine: [
  {
    q: "Is there specific physiotherapy or training for different sports?",
    a: "Yes.\nEach sport involves unique movement patterns and joint demands, placing different joints at varying levels of risk.\nTherefore, sport-specific and individualized rehabilitation programs are designed and guided by a physiotherapist to meet the requirements of each sport."
  },
  {
    q: "Can I return to sports after surgery or ligament or meniscus repair?",
    a: "Yes.\nReturn to sports is possible once the treated condition has adequately healed and you have regained sufficient strength, flexibility, balance, and coordination following the surgical or rehabilitative procedure."
  }
],
trauma: [
  {
    q: "When should ice packs be used and when is hot fomentation advised?",
    a: "Ice packs \nRecommended immediately after an injury when there is pain, swelling, or disability.\n\nHot fomentation:\nUseful for chronic pain, age-related pain, pain due to overactivity, or mechanical overloading of muscles and joints."
  },
  {
    q: "What is a slab and what is a cast?",
    a: "Slab:\nA slab is applied immediately after a fracture as a temporary splint to immobilize the limb.\nSlab material is hard plastic or foam.\nSwelling may increase within 48–72 hours after injury, slab covers only two-thirds of the limb, thus reducing the risk of neurovascular compression.\n\nCast:\nA cast is applied for long-term immobilization.\nCast materials is fiberglass or plaster of Paris (POP).\nIt is usually applied after swelling and inflammation have subsided."
  },
  {
    q: "Which type of cast is better: Fiberglass or POP?",
    a: "Fiberglass cast:\nLightweight and stronger.\nRadiolucent (X-rays can be taken through the cast).\nMore comfortable and preferred, especially for children.\n\nPOP (Plaster of Paris) cast:\nTraditional casting material.\nHeavier and less strong.\nTakes longer to set.\nIts use has significantly decreased in modern practice."
  },
  {
    q: "What should be done if the plaster becomes loose?",
    a: "You should report to your doctor.\nA loose plaster may fail to adequately support the fracture, increasing the risk of displacement and improper healing."
  },
  {
    q: "What should be done if itching occurs under the plaster?",
    a: "Itching occurs because the skin is unable to breathe or come into contact with air and water, leading to accumulation of dead skin.\nKeep the cast dry and clean.\nDo not insert objects inside the cast to scratch.\nInform your doctor if itching becomes severe or persistent."
  }
]
};

export default faqData;
